// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"beu_a bih_rj bih_rk bih_vh bih_eb bih_vf bih_gs bih_kh"};